import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

import { setReleaseSeenBySchoolUser } from '../../actions/school-release-info';

import ReleaseInfoContent from './release-info-content';

class ReleaseInfoModal extends Component {

  constructor(props) {
    super(props);

    const { releaseInfo: { forceUserToGetReleaseNotes } } = this.props;

    this.state = {
      showModal: forceUserToGetReleaseNotes
    };

    this.openReleaseInfoPdf = this.openReleaseInfoPdf.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openReleaseInfoPdf() {
    const { releaseInfo: { pdfLink } } = this.props;
    window.open(pdfLink, '_blank')
      .focus();

    this.closeModal();
  }

  closeModal() {
    const { setReleaseSeenBySchoolUser, releaseInfo: { releaseId } } = this.props;
    setReleaseSeenBySchoolUser(releaseId);

    this.setState({
      showModal: false
    });
  }

  render() {
    const { releaseInfo } = this.props;
    const { showModal } = this.state;

    return (
      <Modal show={showModal} onHide={this.closeModal}>
        <Modal.Header closeButton className='header-release_info'>
          <Modal.Title>New features and improvements</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReleaseInfoContent releaseInfo={releaseInfo}/>
        </Modal.Body>
        <Modal.Footer className='footer-release_info'>     
          <Button onClick={this.closeModal}>
            Dismiss
          </Button>
          <Button onClick={this.openReleaseInfoPdf}>
            Learn More
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(
  state => ({ schoolReleaseInfo: state.schoolReleaseInfo }),
  { setReleaseSeenBySchoolUser }
)(ReleaseInfoModal);



// WEBPACK FOOTER //
// ./src/components/common/release-info-modal.js